import dynamic from 'next/dynamic';

export interface ContentFeedBlockProps {
  contentFeedType: string;
}

// Blocks that have a more advance mapping, eg multiple chunks.
const postContentMappings = {
  'finder/content-feed.default': dynamic(() => {
    return import(
      '@finder/ui-blocks.post-content/default-content-feed' /* webpackChunkName: "ui-blocks.content-feed.default" */
    ).then(({ DefaultContentFeed }) => DefaultContentFeed as React.ComponentType);
  }),

  'finder/content-feed.list': dynamic(() => {
    return import(
      '@finder/ui-blocks.post-content/list-feed' /* webpackChunkName: "ui-blocks.content-feed.list" */
    ).then(({ ListFeed }) => ListFeed as React.ComponentType);
  }),

  'finder/content-feed.guides': dynamic(() => {
    return import(
      '@finder/ui-blocks.post-content/guides-feed' /* webpackChunkName: "ui-blocks.content-feed.guides" */
    ).then(({ GuidesFeed }) => GuidesFeed as React.ComponentType);
  }),

  'finder/content-feed.news': dynamic(() => {
    return import(
      '@finder/ui-blocks.post-content/news-feed' /* webpackChunkName: "ui-blocks.content-feed.news" */
    ).then(({ NewsFeed }) => NewsFeed as React.ComponentType);
  }),

  'finder/content-feed.related-posts': dynamic(() => {
    return import(
      '@finder/ui-blocks.post-content/related-posts-feed' /* webpackChunkName: "ui-blocks.content-feed.posts" */
    ).then(({ RelatedPostsFeed }) => RelatedPostsFeed as React.ComponentType);
  }),
};

export interface ContentFeedBlockProps {
  contentFeedType: string;
}

export const getPostContentComponent = (props: ContentFeedBlockProps): React.ComponentType => {
  const { contentFeedType } = props;

  switch (contentFeedType) {
    case 'news_feed':
      return postContentMappings['finder/content-feed.news'];

    case 'related_post':
      return postContentMappings['finder/content-feed.related-posts'];

    case 'list':
      return postContentMappings['finder/content-feed.list'];

    case 'guides_feed':
      return postContentMappings['finder/content-feed.guides'];

    default:
      return postContentMappings['finder/content-feed.default'];
  }
};
